import type { PendingAnnexDto } from '@bqcrm/shared';
import { Alert } from '@mantine/core';
import { IconFileAlert } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api';

/**
 * P35: aneks sprawy wydany do podpisu, jeszcze niepodpisany — „może zmienić zakres” (planowanie bez blokady).
 * scopeIds — tylko aneksy dotyczące tych zakresów (bez — wszystkie aneksy sprawy).
 */
export function PendingAnnexAlert({ caseId, scopeIds }: { caseId: string; scopeIds?: string[] }) {
  const q = useQuery({ queryKey: ['pending-annexes', caseId], queryFn: () => api<PendingAnnexDto[]>(`/cases/${caseId}/pending-annexes`) });
  const list = (q.data ?? []).filter((a) => !scopeIds?.length || a.scopeIds.some((s) => scopeIds.includes(s)));
  if (!list.length) return null;
  return (
    <Alert color="yellow" variant="light" icon={<IconFileAlert size={18} />} p="xs">
      {list.map((a) => `Aneks ${a.number ?? '(bez numeru)'}`).join(', ')} {list.length > 1 ? 'czekają' : 'czeka'} na podpis — może zmienić zakres prac. Rozważ zaplanowanie po podpisie albo
      uwzględnij prace z aneksu w tej samej wizycie.
    </Alert>
  );
}
